var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"swiper",staticClass:"m-swiper",style:({ height: _vm._height }),on:{"touchstart":_vm.moveStart,"touchmove":_vm.moving,"touchend":_vm.moveEnd}},[_vm._t("default"),_vm._v(" "),_vm._t("indicator",[_c('div',{staticClass:"indicator"},[_vm._v(_vm._s((_vm.active + 1) + '/' + _vm.items.length))])],{"indicator":{current: _vm.active, len: _vm.items.length}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-39c495dc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/lib/swiper/Swiper.vue
// module id = 10
// module chunks = 0